module.exports = __webpack_public_path__ + "static/media/branding_1080p_bl.4ca2032b.png";